import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79483657"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate img-container"
}
const _hoisted_2 = {
  key: 0,
  style: {"overflow":"hidden"}
}
const _hoisted_3 = {
  key: 1,
  class: "img-container"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "profile-text"
}
const _hoisted_6 = {
  key: 2,
  class: "photo"
}

import { ref, onMounted } from 'vue'
import ProfileService from '@/services/ProfileService'
import { useAuth } from '@/store/useAuth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface'
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileImage',
  setup(__props) {

const store = useAuth()
const service = new ProfileService()
const loading = ref(true)
const user = ref()
const isHover = ref(false)
const toast = useToast()

const show = ref(false)
const params = {
				token: store.token,
				name: 'avatar'
}
const headers = {
				smail: '*_~',
                'Authorization': `Bearer ${store.token}`
}

const langExt = {
    hint: 'Pulsa aquí o arrastra la imagen para subirla',
    loading: 'Subiendo...',
    noSupported: 'Este navegador no está soporta,Por favor, usa IE10+ u otro navegador',
    success: 'Subida Exitosa',
    fail: 'Subida Fallida',
    preview: 'Previsualización',
    btn: {
        off: 'Cancelar',
        close: 'Cerrar',
        back: 'Atrás',
        save: 'Guardar'
    },
    error: {
        onlyImg: 'Tan solo se permiten archivos de formato imagen',
        outOfSize: 'La imagen excede el peso máximo: ',
        lowestPx: 'La imagen contiene una resolución myt baja. Se espera al menos: '
    }
}

const imgDataUrl = ref('')

onMounted(async () => {
    if(!store.token) {
        return
    }
    loading.value = true
    user.value = await service.MyUser(store.token)
    loading.value = false
})

const toggleShow = () => {
	show.value = !show.value;
}

const cropSuccess = async (_imgDataUrl:string, field:string|null) => {
    if(!store.token) {
        return
    }
    toast.showToast("Subida Exitosa. La imagen estará disponible en unos minutos. Continua navegando con tranquilidad", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 8000);
    loading.value = true
    user.value = await service.MyUser(store.token)
    loading.value = false
}
			
const cropUploadSuccess = (jsonData:any, field:any) => {
	console.log('field: ' + field);
}
		
const cropUploadFail = (status:any, field:number) => {
    toast.showToast("Error: " + status, Toast.DANGER)
    setTimeout(function () { toast.hideToast() }, 4000);
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_my_upload = _resolveComponent("my-upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).token)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_icon, {
                  name: "ri-loader-2-fill",
                  animation: "spin",
                  class: "icon"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "animate img-profile",
                  onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false)),
                  onClick: toggleShow
                }, [
                  (user.value.profile_picture_uri)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: user.value.profile_picture_uri
                      }, null, 8, _hoisted_4))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(user.value.name.substring(0,1)), 1)),
                  (isHover.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_v_icon, {
                          name: "bi-camera-fill",
                          fill: _unref(main).SECONDARY_COLOR,
                          stroke: "white"
                        }, null, 8, ["fill"])
                      ]))
                    : _createCommentVNode("", true)
                ], 32)
              ]))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_my_upload, {
      field: "image",
      onCropSuccess: cropSuccess,
      onCropUploadSuccess: cropUploadSuccess,
      onCropUploadFail: cropUploadFail,
      modelValue: show.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      width: 300,
      height: 300,
      url: `${_unref(main).BASE_ENDPOINT}/profile/update-picture`,
      params: params,
      headers: headers,
      "lang-ext": langExt,
      "img-format": "png"
    }, null, 8, ["modelValue", "url"])
  ], 64))
}
}

})